import {getPointsHtml, hideContent, runFuseElementsSearch} from "./ui-helpers.js";
import {globals} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js";
import {showSuperstarInformation} from "./booking.js";
import {Superstars} from "../models/models.js";
import {getSuperstarDisplayData} from "../modules/superstars.js";
import {getTradeAvailableSuperstars, makeTradeOffer} from "../modules/trades.js";

function tradeOfferCompetitorSelectHandler(element) {
    let $tradeOfferContainer = $('.trade-offer-container');
    let competitorUid = element.find(':selected').attr('data-uid');
    let competitorName = element.val();

    // Confirm if a trade slot has been selected
    if ($tradeOfferContainer.find('.trade-offer-superstar-item[data-uid]:visible').length > 0) {
        notie.confirm({
            text: 'Are you sure? The existing trade will be reset.',
            submitCallback: function () {
                loadCompetitorTradeOfferBox($tradeOfferContainer, competitorUid, competitorName)
            }
        });
    }
    else {
        loadCompetitorTradeOfferBox($tradeOfferContainer, competitorUid, competitorName)
    }
}

function loadCompetitorTradeOfferBox($tradeOfferContainer, competitorUid, competitorName) {
    const $bookingContainer = $('#booking-container');

    // Add competitor name and uid
    $tradeOfferContainer.find('.trade-offer-receiver-company').attr('data-company-uid', competitorUid);
    $tradeOfferContainer.find('.trade-offer-receiver-company-name').text(competitorName);

    // Reset trade offer
    $tradeOfferContainer.find('.trade-offer-company-container').show();
    $tradeOfferContainer.find('.trade-offer-superstar-item').each(function (i, e) {
        $(e).text('Empty');
        $(e).removeAttr('data-uid');
        $(e).addClass('light-grey');
    });
    $tradeOfferContainer.find('.trade-offer-duration-select').val('3');
    $tradeOfferContainer.find('.trade-offer-info-text').text('');
    $tradeOfferContainer.find('.trade-offer-info-container').hide();
    $tradeOfferContainer.find('.trade-offer-available-superstars-container').hide();
    $tradeOfferContainer.find('.trade-offer-search-container').hide();
    $tradeOfferContainer.find('.select-trade-superstar-button').hide();
    $tradeOfferContainer.find('.remove-trade-superstar-button').hide();
    $tradeOfferContainer.find('.trade-offer-back-button').hide();
    $tradeOfferContainer.find('.make-trade-offer-button').show();
    $tradeOfferContainer.find('.trade-offer-duration-container').show();
    $tradeOfferContainer.find('.trade-offer-competitor-select-container').show();
    $tradeOfferContainer.find('.trade-offer-help-container').show();
    $bookingContainer.hide();

    $bookingContainer.find('.participants-box-match-header, .participants-box-segment-header, .participants-box-match-container, ' +
        '.participants-box-callup-header, .participants-box-segment-container, #add-segment, #booking-talent-menu, #championship_info, ' +
        '.participants-box-draft-header, #booking-talent-container').hide();
    $bookingContainer.find('.participants-box-trade-offer-header').show();

    // Show trade offer container
    if ($tradeOfferContainer.is(':visible')) {
        hideContent($());
        $tradeOfferContainer.show();
    }
    else {
        hideContent($());
        $tradeOfferContainer.fadeIn('fast');
    }
}

function goBackToTradeOffer() {
    let parent = $('.trade-offer-container');
    parent.find(".trade-offer-available-superstars-container").fadeOut('fast', function () {
        parent.find('.trade-offer-company-container').fadeIn('fast');
        parent.find('.select-trade-superstar-button').hide();
        parent.find('.remove-trade-superstar-button').hide();
        parent.find('.trade-offer-back-button').hide();
        parent.find('.trade-offer-search-container').hide();
        parent.find('.make-trade-offer-button').show();
        parent.find('.trade-offer-duration-container').show();
        parent.find('.trade-offer-competitor-select-container').show();
        $('#booking-container').hide();
    });
}

function runTradeSuperstarsSearch() {

    let tradeContainer = $('.trade-offer-container');
    let availableSuperstarsContainer = tradeContainer.find('.trade-offer-available-superstars-container');
    let availableSuperstarsElements = tradeContainer.find('.trade-offer-available-superstar-item:not(.no-trade-search-results)')
    let searchTerm = tradeContainer.find(".trade-offer-search-input").val();

    availableSuperstarsElements.hide();

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(availableSuperstarsElements, searchTerm, ['textContent']);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function (e) {
                $(e).show()
            });
            $('.no-trade-search-results').hide();
        }
        else {
            const $noSearchResults = $('.no-trade-search-results');
            if ($noSearchResults.length > 0) {
                $noSearchResults.show()
            }
            else {
                availableSuperstarsContainer.append('<div class="no-trade-search-results inner-box-item ' +
                    'trade-offer-available-superstar-item disabled light-grey">No Results Found</div>')
            }
        }
    }
    else {
        availableSuperstarsElements.show();
        $('.no-trade-search-results').hide();
    }

    availableSuperstarsContainer.scrollTop(0);
    availableSuperstarsContainer[0].scrollIntoView();
}

async function loadTradeSuperstarsSelectPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getTradeAvailableSuperstars(companyUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showTradeSuperstarsSelectPage(data);
}

function showTradeSuperstarsSelectPage(data) {
    let html = '';
    data['availableSuperstars'].forEach(function(availableSuperstar) {
        html += getAvailableTradeSuperstarHtml(availableSuperstar)
    });

    let $tradeOfferContainer = $('.trade-offer-container');
    $tradeOfferContainer.find('.trade-offer-available-superstars-container').html(html);
    $tradeOfferContainer.find(".trade-offer-company-container").fadeOut('fast', function () {
        $tradeOfferContainer.find('.trade-offer-available-superstars-container').fadeIn('fast');
        $tradeOfferContainer.find('.trade-offer-available-superstars-container').scrollTop(0);

        $tradeOfferContainer.find('.trade-offer-duration-container').hide();
        $tradeOfferContainer.find('.trade-offer-competitor-select-container').hide();
        $tradeOfferContainer.find('.make-trade-offer-button').hide();
        $tradeOfferContainer.find('.select-trade-superstar-button').show();
        $tradeOfferContainer.find('.trade-offer-search-container').show();
        $tradeOfferContainer.find('.trade-offer-back-button').show();
        $tradeOfferContainer.find(".trade-offer-search-input").val('');

        // Show remove button if superstar slot has superstar selected
        let superstarsContainer = $tradeOfferContainer.find('.trade-offer-superstars-container.current-selection');
        let selectedSlot = superstarsContainer.find('.trade-offer-superstar-item.current-selection');
        if (selectedSlot.attr('data-uid')) {
            $tradeOfferContainer.find('.remove-trade-superstar-button').show();
        }
        else {
            $tradeOfferContainer.find('.remove-trade-superstar-button').hide();
        }
    });
}

function getAvailableTradeSuperstarHtml(superstar) {
    let popularity = '<span class="margin-left-15">' +
                     superstar['popularity'] + '</span>';
    let appearances = (superstar['appearances'] !== null) ?
        '<span class="medium-light-grey">' + superstar['appearances'] + ' apps.</span>' : '';

    // Superstar name, color and help text
    let superstarNameClass = '';
    let superstarHelpTexts = [];
    if (superstar['appearances'] !== null) {
        superstarNameClass = 'blue';
        superstarHelpTexts.push('Part-timer')
    }
    if (superstar['injured']) {
        superstarNameClass = 'dark-red';
        superstarHelpTexts.push('Injured');
    }
    if (superstar['retired']) {
        superstarNameClass = 'light-grey';
        superstarHelpTexts.push('Retired');
    }
    if (superstar['fullTimeManager']) {
        superstarNameClass = 'manager-color';
        superstarHelpTexts.push('Full-time Manager');
    }

    let superstarName;
    if (superstarHelpTexts.length > 0) {
        superstarName = '<div class="line-height-1p4 ' + superstarNameClass +
            ' help-text display-inline-block" title="' + superstarHelpTexts.join(', ') + '">' + superstar['name']  +
            '</div>'
    }
    else if (superstarNameClass) {
        superstarName = '<div class="line-height-1p4 display-inline-block' +
            superstarNameClass + '">' + superstar['name']  + '</div>'
    }
    else {
        superstarName = '<div class="line-height-1p4 display-inline-block">' +
            superstar['name'] + '</div>'
    }

    let unavailableClass = '';
    if (superstar['isChampion'] || superstar['onTradeDeal'] || superstar['booked'] ||
        superstar['contractMonthsRemaining'] || superstar['partOfTradeOffer'] || superstar['isOwner'] ||
        superstar['powStar']) {
        unavailableClass = ' unavailable';
    }

    return '<div class="inner-box-item trade-offer-available-superstar-item' + unavailableClass + '" data-uid="' + superstar['uid'] +
        '" data-is-champion="' + superstar['isChampion'] +  '" data-on-trade-deal="' + superstar['onTradeDeal'] +
        '" data-booked="' + superstar['booked'] +  '" data-contract-months-remaining="' + superstar['contractMonthsRemaining'] +
        '" data-part-of-trade-offer="' + superstar['partOfTradeOffer'] + '" data-is-owner="' + superstar['isOwner'] +
        '" data-pow-star="' + superstar['powStar'] + '">' +
            '<div class="trade-offer-available-superstar-name">' +
                superstarName +
            '</div>' +
            '<div class="trade-offer-available-superstar-details">' +
                '<span>' +
                appearances + popularity +
                '</span>' +
            '</div>' +
            '<div class="clear"></div>' +
        '</div>';
}

async function getMakeTradeOfferRequest(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    // _make_trade_offer
    let data = await makeTradeOffer(offeredSuperstarsUids, requestedSuperstarsUids, duration, companyUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showMakeTradeOfferData(data);
}

function showMakeTradeOfferData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let $tradeOfferContainer = $('.trade-offer-container');
        $tradeOfferContainer.find('.trade-offer-info-text').text('Your offer was sent to {0}. You should receive a reply in your messages.'.format(data['competitorName']));
        $tradeOfferContainer.find('.trade-offer-info-container').show();
        $tradeOfferContainer.find('.trade-offer-company-container').hide();
        $tradeOfferContainer.find('.trade-offer-duration-container').hide();
        $tradeOfferContainer.find('.trade-offer-competitor-select-container').hide();
        $tradeOfferContainer.find('.trade-offer-help-container').hide();
        $tradeOfferContainer.find('.make-trade-offer-button').hide();

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Update unread messages
        if (data['unreadMessages']) {
            let unreadMessages = data['unreadMessages'].toLocaleString('en');
            $('.messages-icon').attr('src', 'static/www/static/message_alert_icon.png');
            $('.messages-number').text(unreadMessages);
            $('#messages').hide().fadeIn('fast');
        }
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'competitor-not-found') {
            notie.alert({type: 3, text: 'That Competitor could not be found. Please try again.'});
        }
        if (data['error'] === 'superstars') {
            notie.alert({type: 3, text: 'Those Superstars could not be found. Please try again.'});
        }
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: 'You do not have enough Creative Points to make this offer.'});
        }
        if (data['error'] === 'mars') {
            notie.alert({type: 3, text: 'Trades are not available in Wrestling on Mars'});
        }
    }
}

async function loadTradeSuperstarInfoPage(uid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let superstar = Superstars.get(uid);
    let data = await getSuperstarDisplayData({superstar: superstar, getTeamsAndFactions: true});
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showSuperstarInformation(data, false, true, false, true);
}

export {tradeOfferCompetitorSelectHandler, loadCompetitorTradeOfferBox, runTradeSuperstarsSearch, goBackToTradeOffer,
    loadTradeSuperstarsSelectPage, getMakeTradeOfferRequest, loadTradeSuperstarInfoPage}